module.exports = __webpack_public_path__ + "static/flags/CU-2c56745257109af8fedd1d560a2162d6.gif";